














import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { language } from '@tencent/ppd-base-libs';
import Icon from '@/hk-cv-base/components/icon/icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class ListItem extends Vue {
  @Prop() public name!: string;
  @Prop() public desc!: string;
  public lang = language.getLanguage();
  @Emit('clickItem')
  private clickItem() {}
}
